import { Outlet } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "../hooks/useTranslations";

const I18nProvider = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <Outlet />
    </I18nextProvider>
  );
};

export default I18nProvider;
